module.exports = __webpack_public_path__ + "img/story043@2x.58847b6c.png";